/**
 * Posts the CMS points the home page's social columns at.
 *
 * Only the link is stored. Each platform renders its own card in the browser —
 * X and Instagram turn a blockquote into an embed with their own script,
 * LinkedIn serves an iframe — so nothing here can go stale and no API key is
 * needed. Empty until the CMS answers: an invented post is worse than none.
 */
export type SocialNetwork = 'x' | 'instagram' | 'linkedin';

export interface SocialPost {
    network: SocialNetwork;
    /** The post's public address, for the "open on <platform>" fallback. */
    url: string;
    /** What actually gets embedded — for LinkedIn this is its embed address. */
    embedUrl: string;
    caption: string;
}

export const SOCIAL_POSTS: SocialPost[] = [];

export const postsFor = (network: SocialNetwork): SocialPost[] => SOCIAL_POSTS.filter((p) => p.network === network);
